function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FixedSizeList as List } from 'react-window';
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize, faWindowMinimize, faTimes, faSync, faLocationArrow } from '@fortawesome/free-solid-svg-icons';
import EventFilter from './EventFilter';
import RaceRow from './RaceRow';
import './RaceList.css';
var ROW_HEIGHT = 150;

var RaceList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RaceList, _React$PureComponent);

  function RaceList(props) {
    var _this;

    _classCallCheck(this, RaceList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RaceList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onOrientationChange", function (e) {
      _this.setState({
        width: innerWidth - 50,
        maxHeight: innerHeight - 150
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResize", function () {
      _this.setState({
        maxHeight: innerHeight - 150
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;
      var _this$props = _this.props,
          app = _this$props.app,
          raceList = _this$props.raceList,
          tracks = _this$props.tracks;
      var race = raceList[index];
      return React.createElement("div", {
        className: "race-row-container",
        style: style,
        key: race.id
      }, React.createElement(RaceRow, {
        app: app,
        race: race,
        tracks: tracks
      }));
    });

    _this.state = {
      maxHeight: innerHeight - 150,
      minimized: true,
      isApp: window.cordova !== undefined,
      width: isMobile ? innerWidth - 50 : 375
    };
    return _this;
  }

  _createClass(RaceList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isMobile) {
        window.addEventListener('orientationchange', this.onOrientationChange);
      } else {
        window.addEventListener('resize', this.onWindowResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (isMobile) {
        window.removeEventListener('orientationchange', this.onOrientationChange);
      } else {
        window.removeEventListener('resize', this.onWindowResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var renderRow = this.renderRow;
      var _this$props2 = this.props,
          app = _this$props2.app,
          raceList = _this$props2.raceList,
          categoryFilterOptions = _this$props2.categoryFilterOptions,
          categoryFilters = _this$props2.categoryFilters,
          regionFilterOptions = _this$props2.regionFilterOptions,
          regionFilters = _this$props2.regionFilters,
          activeTrack = _this$props2.activeTrack,
          moveMapToCurrentLocation = _this$props2.moveMapToCurrentLocation;
      var _this$state = this.state,
          maxHeight = _this$state.maxHeight,
          minimized = _this$state.minimized,
          isApp = _this$state.isApp,
          width = _this$state.width;
      var hasRaces = raceList && raceList.length > 0;
      var style = {};

      if (isMobile) {
        style.width = "".concat(width, "px");

        if (activeTrack) {
          if (isApp) {
            style.top = "210px";
          } else {
            style.top = "200px";
          }
        } else if (isApp) {
          style.top = "35px";
        }
      }

      var listHeight = 0;

      if (isMobile) {
        if (raceList) {
          if (!minimized) {
            var maxListHeight = activeTrack ? innerHeight - 445 : innerHeight - 270;

            if (isApp) {
              maxListHeight -= 10;
            }

            listHeight = raceList ? Math.min(maxListHeight, raceList.length * ROW_HEIGHT) : 0;
          }
        }
      } else {
        listHeight = raceList ? Math.min(maxHeight, raceList.length * ROW_HEIGHT - 10) : 0;
      }

      return React.createElement("div", {
        className: "race-list ".concat(raceList ? 'show' : 'hide', " ").concat(this.props.searchMode),
        style: style
      }, React.createElement("div", {
        className: "header ".concat(!hasRaces ? 'no-events' : '')
      }, React.createElement("div", {
        className: "title"
      }, !hasRaces && React.createElement("div", {
        className: "caption"
      }, "no events found"), raceList && raceList.length > 0 && React.createElement("div", {
        className: "count"
      }, raceList.length), raceList && raceList.length === 1 && React.createElement("div", {
        className: "caption"
      }, "event"), raceList && raceList.length > 1 && React.createElement("div", {
        className: "caption"
      }, "events")), React.createElement("div", {
        className: "current-location",
        onClick: moveMapToCurrentLocation
      }, React.createElement(FontAwesomeIcon, {
        icon: faLocationArrow
      })), isMobile && minimized && React.createElement("div", {
        className: "maximize",
        onClick: function onClick(e) {
          return _this2.setState({
            minimized: false
          });
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faWindowMaximize
      })), isMobile && !minimized && React.createElement("div", {
        className: "minimize",
        onClick: function onClick(e) {
          return _this2.setState({
            minimized: true
          });
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faWindowMinimize
      })), React.createElement("div", {
        className: "refresh",
        onClick: function onClick(e) {
          return app.refreshData();
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faSync
      })), React.createElement("div", {
        className: "close",
        onClick: function onClick(e) {
          return app.closeRaceList();
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faTimes
      }))), React.createElement("div", {
        className: "filters"
      }, categoryFilterOptions.map(function (option) {
        return React.createElement(EventFilter, {
          filter: option,
          options: categoryFilters,
          key: option,
          toggleFilter: app.toggleCategoryFilter
        });
      })), React.createElement("div", {
        className: "region-filters"
      }, regionFilterOptions.map(function (option) {
        return React.createElement(EventFilter, {
          filter: option,
          options: regionFilters,
          key: option,
          toggleFilter: app.toggleRegionFilter
        });
      })), React.createElement(List, {
        className: "race-row-list",
        height: listHeight,
        itemCount: raceList ? raceList.length : 0,
        itemSize: ROW_HEIGHT - 10,
        width: width
      }, renderRow));
    }
  }]);

  return RaceList;
}(React.PureComponent);

export default RaceList;